import React from "react";
import clsx from "clsx";
import { DebugModeContext } from "/src/helpers/contexts/agentContext";

const FilterCheckboxItem = ({ option, type, idx, onChange, selected }) => {
    const inputId = `filter-${type}-${option.key}`;
    const labelClasses = clsx(
        { "text-sm": true },
        { "text-gray-600": option.isAvailable },
        { "text-gray-400": !option.isAvailable }
    );

    return (
        <div
            key={option.value}
            className="flex gap-3 cursor-pointer"
            // Hierarchical facets (the merged Destination list) indent by level:
            // 0 = country, 1 = region, 2 = resort.
            style={option.level ? { paddingLeft: `${option.level * 16}px` } : undefined}
        >
            <div className="flex h-5 shrink-0 items-center">
                <div className="group grid size-4 grid-cols-1">
                    <input
                        onChange={(e) => onChange(e.target)}
                        checked={selected}
                        disabled={!option.isAvailable}
                        id={inputId}
                        type="checkbox"
                        className="col-start-1 row-start-1 appearance-none rounded-sm border border-gray-300 bg-white checked:border-indigo-600 checked:bg-indigo-600 indeterminate:border-indigo-600 indeterminate:bg-indigo-600 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:border-gray-300 disabled:bg-gray-100 disabled:checked:bg-gray-100 forced-colors:appearance-auto"
                    />
                    <svg
                        fill="none"
                        viewBox="0 0 14 14"
                        className="pointer-events-none col-start-1 row-start-1 size-3.5 self-center justify-self-center stroke-white group-has-disabled:stroke-gray-950/25"
                    >
                        <path
                            d="M3 8L6 11L11 3.5"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="opacity-0 group-has-checked:opacity-100"
                        />
                        <path
                            d="M3 7H11"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="opacity-0 group-has-indeterminate:opacity-100"
                        />
                    </svg>
                </div>
            </div>
            <label htmlFor={inputId} className={labelClasses}>
                {option.name} ({option.count})
            </label>
        </div>
    );
};

const FilterCheckboxList = ({ model, events }) => {
    return model.options.map((option, optionIdx) => {
        const isSelected = events.isSelected(model.key, option.key);
        const onChangeHandler = (e) => {
            if (isSelected) {
                events.removeOption(model.key, option.key);
            } else {
                events.addOption(model.key, option.key);
            }
        };

        return (
            <FilterCheckboxItem
                option={option}
                selected={isSelected}
                type={model.key}
                idx={optionIdx}
                key={optionIdx}
                onChange={onChangeHandler}
            />
        );
    });
};
export default FilterCheckboxList;
